/**
 * Medical Leaves Filters Component
 * Inline filter bar: filters stay visible and apply live (no popover).
 */
import React from 'react';
import { TextField } from '@mui/material';
import { InlineFilterBar } from '../../../components/common';
import { useFilterState } from '../../../hooks/useFilterState';

export interface LeaveFiltersData {
  searchTerm: string;
  startDate: string;
  endDate: string;
}

interface Props {
  onFilter: (filters: LeaveFiltersData) => void;
  loading?: boolean;
  total?: number;
}

const defaultValues: LeaveFiltersData = {
  searchTerm: '',
  startDate: '',
  endDate: '',
};

export const MedicalLeavesFiltersComponent: React.FC<Props> = ({
  onFilter,
  loading = false,
  total,
}) => {
  const { filters, setFilter, clearAll, activeChips } = useFilterState(defaultValues, {
    onFilter,
    applyOnMount: true,
    live: true,
    labels: { startDate: 'Data Início', endDate: 'Data Fim' },
  });

  return (
    <InlineFilterBar
      searchPlaceholder="Buscar por funcionário, empresa, setor, CID..."
      searchValue={filters.searchTerm}
      onSearchChange={(v) => setFilter('searchTerm', v)}
      resultCount={total}
      resultNoun="afastamentos"
      chips={activeChips}
      onClearAll={clearAll}
      loading={loading}
    >
      <TextField
        size="small"
        type="date"
        label="Data Início"
        value={filters.startDate}
        onChange={(e) => setFilter('startDate', e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 160 }}
      />
      <TextField
        size="small"
        type="date"
        label="Data Fim"
        value={filters.endDate}
        onChange={(e) => setFilter('endDate', e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 160 }}
      />
    </InlineFilterBar>
  );
};

export default MedicalLeavesFiltersComponent;
